import { createAction, handleActions } from "redux-actions";
import createPromiseThunk from "lib/createPromiseThunk";
import * as api from "lib/api/register";

const REGISTER = "register/RECRUIT_VIEW";
const REGISTER_PENDING = "register/RECRUIT_VIEW_PENDING";
const REGISTER_SUCCESS = "register/RECRUIT_VIEW_SUCCESS";

const MAIL_DUPLICATE = "register/MAIL_DUPLICATE";
const CHANGE_ALWAYS = "register/ALWAYS";
const FORM_DATA = "register/FORM_DATA";
const STEP_NEXT = "register/STEP_NEXT";
const JOIN_SUCCESS = "register/JOIN_SUCCESS";

export const register = createPromiseThunk(REGISTER, api.register);
export const mailDuplicate = createPromiseThunk(
  MAIL_DUPLICATE,
  api.mailDuplicate
);
export const changeAlways = createAction(CHANGE_ALWAYS);
export const formData = createAction(FORM_DATA);
export const stepNext = createAction(STEP_NEXT);
export const joinSuccess = createAction(JOIN_SUCCESS);

const initialState = {
  // data: null,
  nextPage: 1,
  userNm: "",
  email: "",
  isAlways: "Y",
  loading: false
};

export default handleActions(
  {
    [CHANGE_ALWAYS]: (state, { payload }) => ({
      ...state,
      isAlways: payload
    }),
    [FORM_DATA]: (state, { payload }) => ({
      ...state,
      data: { ...state.data, ...payload }
    }),
    [STEP_NEXT]: (state, { payload }) => ({
      ...state,
      nextPage: payload
    }),
    [JOIN_SUCCESS]: (state, { payload }) => ({
      ...state,
      ...payload
      // userNm: payload,
      // email: payload
    }),
    [REGISTER_PENDING]: state => ({
      ...state,
      loading: true
    }),
    [REGISTER_SUCCESS]: state => ({
      ...state,
      loading: false
    })
  },
  initialState
);
